<template>
  <div class="card">
    <div v-if="!hideHeader" class="card-header">
      <!-- O <h3></h3> que existia aqui era um cabeçalho VAZIO: entrava na lista de
           cabeçalhos do leitor de tela (e no painel "Estrutura da Página" do widget de
           acessibilidade) como um item sem texto, em toda listagem do sistema. -->
      <div class="d-flex flex-row bd-highlight pt-2">
        <slot name="header"> </slot>
        <ConsulteGridViews v-if="showViewsManager" v-model:columns="columnsData" @on-select-view="onSelectView">
        </ConsulteGridViews>
        <button title="Filtrar dados do grid" v-if="
          showFilterButton &&
          $refs.componentFilter &&
          $refs.componentFilter.filterableColumns &&
          $refs.componentFilter.filterableColumns?.length > 0
        " class="btn btn-soft-secondary btn-sm ms-1" type="button" data-bs-toggle="offcanvas"
          :data-bs-target="`[id='${idFilters.toString()}']`" :aria-controls="idFilters.toString()"
          aria-label="Filtrar dados do grid">
          <i class="uil-search-alt" aria-hidden="true"></i>
        </button>

        <button title="Selecionar Colunas Grid" v-if="showColumnSelectionButton && $refs.componentColumnsSelection"
          class="btn btn-soft-secondary btn-sm ms-1" type="button" data-bs-toggle="offcanvas"
          :data-bs-target="`[id='${idColumns.toString()}']`" :aria-controls="idColumns.toString()"
          aria-label="Selecionar Colunas Grid">
          <i class="uil-grid" aria-hidden="true"></i>
        </button>

        <div class="dropdown" v-if="false">
          <button class="btn btn-primary dropdown-toggle ms-1 me-2" type="button" data-bs-toggle="dropdown">
            <i class="uil-print" aria-hidden="true"></i> Exportar
          </button>
          <ul class="dropdown-menu">
            <li><button type="button" class="dropdown-item" @click="imprimirExportar('PDF')">PDF</button></li>
            <li><button type="button" class="dropdown-item" @click="imprimirExportar('HTML')">HTML</button></li>
            <li><button type="button" class="dropdown-item" @click="imprimirExportar('XLSX')">XLSX</button></li>
            <li><button type="button" class="dropdown-item" @click="imprimirExportar('DOC')">DOC</button></li>
            <li><button type="button" class="dropdown-item" @click="imprimirExportar('PÁGINA')">TELA</button></li>
          </ul>
        </div>

        <button title="Limpar Ordenação" v-if="sortFields?.length > 0" class="btn btn-soft-secondary btn-sm ms-1 me-2"
          type="button" @click="clearGridSort()"
          aria-label="Limpar Ordenação">
          <i class="ri-sort-asc" aria-hidden="true"></i>
        </button>
      </div>
      <div class="alert alert-primary bg-transparent text-primary mt-3 mx-3 font-10" role="alert"
        v-if="sortFields?.length > 0">
        {{ sortFields }}
      </div>
    </div>

    <div v-if="onlySearchHeader" class="card-header">
      <div class="d-flex flex-row bd-highlight">
        <button title="Filtrar dados do grid" v-if="
          showFilterButton &&
          $refs.componentFilter &&
          $refs.componentFilter.filterableColumns &&
          $refs.componentFilter.filterableColumns?.length > 0
        " class="btn btn-soft-secondary btn-sm ms-auto" type="button" data-bs-toggle="offcanvas"
          :data-bs-target="`[id='${idFilters.toString()}']`" :aria-controls="idFilters.toString()"
          aria-label="Filtrar dados do grid">
          <!-- O texto estava DENTRO do <i>: marcar o <i> como aria-hidden (como nos
               outros ícones) apagaria a palavra "Pesquisar" do leitor de tela. -->
          <i class="uil-search-alt" aria-hidden="true"></i> Pesquisar
        </button>
      </div>
    </div>
    <div class="card-body pt-1">
      <ConsulteGridFilters :id-filters="idFilters.toString()" :columns="columnsData" :data-source="dataSource"
        ref="componentFilter"></ConsulteGridFilters>
      <ConsulteGridColumnSelection :id-columns="idColumns.toString()" v-model:columns="columnsData"
        :data-source="dataSource" ref="componentColumnsSelection"></ConsulteGridColumnSelection>
      <!--
        Barra de rolagem espelhada ACIMA da grade, por opt-in (`barra-rolagem-superior`). A barra
        nativa mora no rodapé da tabela: numa grade alta, arrastar as colunas obriga a descer a
        listagem inteira e voltar. O trilho de dentro recebe por JS a largura do conteúdo, e é isso
        que dá a esta barra o mesmo curso da de baixo.

        Fica FORA do `.table-responsive` de propósito: dentro, ela rolaria junto com o conteúdo e
        sairia da tela justamente quando é necessária.
      -->
      <div v-if="barraRolagemSuperior" v-show="precisaRolagemHorizontal" ref="rolagemSuperior"
        class="consulte-grid-rolagem-superior" aria-hidden="true" @scroll="sincronizarRolagem('superior')">
        <div class="consulte-grid-rolagem-superior-trilho" :style="{ width: `${larguraDoConteudo}px` }"></div>
      </div>

      <div class="table-responsive ps" ref="areaRolagemExterna" @scroll="sincronizarRolagem('area')">
        <!--
          Barra de carregamento INDETERMINADA (não se sabe quanto falta).

          Trazia `aria-valuenow="100"` fixo: enquanto a consulta rodava, o leitor de tela
          anunciava "100 por cento" — informação falsa, e a única que existia, porque a
          barra também não tinha nome acessível (WCAG 4.1.2 / 1.3.1).

          Barra indeterminada NÃO leva `aria-valuenow`/`min`/`max`: a ausência do valor é
          justamente o que a marca como indeterminada. O que ela precisa é de nome, e o
          resultado da consulta já é anunciado pela região viva no fim do componente.
        -->
        <div class="progress" style="height: 8px; border-radius: 0px" v-if="dataSource?.loading">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
            aria-label="Carregando registros" style="width: 100%"></div>
        </div>
        <!--
          Lista de filtros aplicados. Era um <h4>: entrava na navegação por cabeçalhos do
          leitor de tela (e no painel "Estrutura da Página" do widget) como se fosse uma
          seção da tela, com o conteúdo dos filtros por texto — além de pular de <h1> para
          <h4> na hierarquia (WCAG 1.3.1 / 2.4.10). Cabeçalho é estrutura, não tamanho de
          fonte: a classe `.h5` continua dando a aparência.
        -->
        <div class="col-12" v-if="showAppliedFilters">
          <div class="h5" role="group" aria-label="Filtros aplicados à listagem">
            <span class="badge bg-success me-1" :key="key"
              v-for="key in Object.keys($refs.componentFilter?.flitersToDisplay ?? {})">
              {{ $refs.componentFilter.getDescriptionFilter(key) }}
              <span class="badge bg-light text-dark ms-1 me-1">{{
                $refs.componentFilter.getDescriptionFilterExpression(key)
                }}</span>
              <strong style="font-weight: normal">{{
                $refs.componentFilter.flitersToDisplay[key]
                }}</strong></span>
          </div>
        </div>
        <table class="table tablesorter table-mobile" v-if="windowWidth <= 600">
          <tbody>
            <!-- O spinner era uma <div> solta dentro do <tbody>. O navegador move
                 conteúdo inválido de tabela para FORA dela, então o indicador aparecia
                 deslocado e a tabela perdia a estrutura de linhas para o leitor de
                 tela. Agora está numa linha/célula de verdade. -->
            <tr v-if="dataSource?.loading" class="mobile-table-row">
              <td class="mobile-row">
                <div class="col-1 mini-loader" role="status">
                  <div class="spinner-border text-primary" aria-hidden="true"></div>
                  <span class="apenas-leitor-tela">Carregando registros...</span>
                </div>
              </td>
            </tr>
            <tr v-if="!dataSource?.loading && (dataSource?.rows?.length ?? 0) == 0" class="mobile-table-row">
              <td class="mobile-row"><i>Nenhum resultado</i></td>
            </tr>
            <slot name="body">
              <tr v-for="row in dataSource?.rows" :key="(row as any)" :class="'mobile-table-row ' + row._rowClass">
                <td v-if="selectable">
                  <div class="mobile-row-header"></div>
                  <div class="mobile-row-cell">
                    <div class="form-check mb-2">
                      <input type="checkbox" @change="onChangeSelection" :value="row" v-model="rowsSelected"
                        class="form-check-input" :aria-label="rotuloSelecaoLinha(row, 0)" />
                    </div>
                  </div>
                </td>
                <td v-if="actions" class="mobile-row mb-1">
                  <div class="mobile-row-header">{{ tituloActions }}</div>
                  <div class="mobile-row-cell">
                    <slot name="actions" :row="row"> </slot>
                  </div>
                </td>
                <td v-if="buttonClickSave" class="mobile-row mb-1">
                  <div class="mobile-row-header"></div>
                  <div class="mobile-row-cell">
                    <button title="Salvar dados da linha" @click="onChangeDataRow(row, $event)"
                      class="btn btn-sm btn-success" style="margin-right: 5px"
                      aria-label="Salvar dados da linha">
                      <i class="mdi mdi-floppy" aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
                <td v-for="(column, index) in columnsData" :key="column.datafield" class="mobile-row">
                  <div class="mobile-row-header">
                    <b>{{ getColumnByDataField(column.datafield)?.text }}</b>
                  </div>
                  <div class="mobile-row-cell">
                    <slot :name="column.datafield" :row="row">
                      <div v-if="column.cellsrenderer" v-html="column.cellsrenderer(
                        index,
                        column.datafield,
                        (row as any)[column.datafield]
                      )
                        "></div>
                      <div
                        v-if="!column.cellsrenderer && !column.columntype && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)">
                        {{ (row as any)[column.datafield] }}
                      </div>

                      <div
                        v-if="!column.cellsrenderer && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) == 'number'">
                        <input
                          :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                          @change="buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)" type="number"
                          v-model="(row as any)[column.datafield]" :aria-label="column.text" class="form-control" />
                      </div>

                      <div
                        v-if="!column.cellsrenderer && column.editinputdefinition == undefined && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) != 'number'">
                        <input
                          :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                          @change="buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)" type="text"
                          v-model="(row as any)[column.datafield]" :aria-label="column.text" class="form-control" />
                      </div>
                      <div
                        v-if="!column.cellsrenderer &&
                          ((typeof column.editinputdefinition === 'object' && (column.editinputdefinition as any).type == 'textarea') || typeof column.editinputdefinition === 'string' && column.editinputdefinition == 'textarea')
                          && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) != 'number'">
                        <textarea
                          :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                          @change="buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)"
                          :rows="(typeof column.editinputdefinition === 'object') ? ((column.editinputdefinition as any)?.rows ?? 1) : 1"
                          v-model="(row as any)[column.datafield]" :aria-label="column.text" class="form-control"></textarea>
                      </div>
                      <div
                        v-if="column.columntype && column.columntype == 'number' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)">
                        <input
                          :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                          @change="buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)" type="number"
                          v-model="(row as any)[column.datafield]" :aria-label="column.text" class="form-control" />
                      </div>
                      <div class="form-check" v-if="column.columntype && column.columntype == 'checkbox'">
                        <label class="form-check-label">
                          <input class="form-check-input" type="checkbox" v-model="(row as any)[column.datafield]" :aria-label="column.text"
                            :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)" />
                          <span class="form-check-sign"></span>
                        </label>
                      </div>
                      <div v-if="column.columntype && column.columntype == 'date' && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)
                      ">
                        {{ new Date((row as any)[column.datafield]).toLocaleDateString() }}
                      </div>
                      <div v-if="column.columntype && column.columntype == 'date' && column.editable">
                        <!--
                        `false` no lugar de `column.editable == false`: o v-if acima termina
                        em `&& column.editable`, então aqui editable é necessariamente truthy e
                        a comparação era sempre falsa — o TypeScript acusava 'true e false não
                        têm sobreposição' (TS2367). Comportamento idêntico ao de antes.
                        -->
                        <input
                          :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : false)"
                          @change="buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)"
                          class="form-control" type="date" v-model="(row as any)[column.datafield]" :aria-label="column.text" />
                      </div>

                      <div v-if="column.columntype && column.columntype == 'datetime' && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                      ">
                        {{
                          (row as any)[column.datafield]
                            ? moment(new Date((row as any)[column.datafield])).format(
                              'DD/MM/yyyy HH:mm'
                            )
                            : ''
                        }}
                      </div>
                      <div v-if="column.columntype && column.columntype == 'datetime' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                      ">
                        <input
                          :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                          @change="buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)"
                          class="form-control" type="datetime-local" v-model="(row as any)[column.datafield]" :aria-label="column.text" />
                      </div>
                    </slot>
                  </div>
                </td>
              </tr>
            </slot>
          </tbody>
        </table>

        <!--
          `undefined` e nao `null` no id: os dois REMOVEM o atributo no Vue 3, então o
          comportamento é o mesmo, mas a tipagem de HTMLAttributes declara `string |
          undefined` e recusava o null (TS2322).
        -->
        <div :id="useFreezedColumn() ? 'table-scroll' : undefined" :class="{ 'table-scroll': useFreezedColumn() }">
          <!--
            Com coluna fixa é ESTE div que rola (`.table-wrap`), não o `.table-responsive` de fora.
            Por isso a barra espelhada escuta os dois: `sincronizarRolagem` descobre qual deles
            transborda em vez de supor um.
          -->
          <div :class="{ 'table-wrap': useFreezedColumn() }" ref="areaRolagemInterna"
            @scroll="sincronizarRolagem('area')">
            <table :class="{
              'main-table mb-1 table-centered mb-0': useFreezedColumn(),
              'table mb-1 table-centered mb-0': !useFreezedColumn(),
            }" v-if="windowWidth > 600" id="tabelaConsulteGrid">
              <thead class="text-primary" v-if="!hideHeaderGrid">
                <tr>
                  <!-- Cabeçalhos que eram vazios: uma coluna sem nome é lida como
                       "coluna em branco" e o usuário não sabe o que há nela. O texto é
                       só para leitor de tela, então a grade continua igual na tela. -->
                  <th v-if="selectable" scope="col">
                    <span class="apenas-leitor-tela">Selecionar</span>
                  </th>
                  <th v-if="rowDetails" scope="col">
                    <span class="apenas-leitor-tela">Detalhes</span>
                  </th>
                  <th v-if="actions" :class="{ 'fixed-side': useFreezedColumn() }" scope="col">
                    {{ tituloActions }}
                  </th>
                  <th v-if="buttonClickSave" scope="col">
                    <span class="apenas-leitor-tela">Salvar</span>
                  </th>
                  <!--
                    `aria-sort` é o que informa a ordenação ao leitor de tela: sem ele o
                    usuário clica em "Ordenar por Nome" e nada é anunciado — não há como
                    saber se a coluna passou a ser crescente, decrescente ou nada.
                  -->
                  <th v-for="column in columnsData" :key="column.datafield" :hidden="column.hidden"
                    :class="{ 'fixed-side': column.freezedcolumn }" :style="getColumnStyle(column)"
                    class="consulte-grid-th-resizable" :data-datafield="column.datafield"
                    scope="col" :aria-sort="direcaoOrdenacaoAria(column)">
                    <!--
                      Slot de CABEÇALHO por coluna, com o texto da coluna como padrão.

                      Serve para o cabeçalho que precisa de um controle, e não só de um rótulo — o
                      caso que motivou é a caixa "marcar todos" da coluna de seleção: numa escola
                      com quarenta turmas, marcar uma a uma é inviável. Como o padrão é o próprio
                      `column.text`, nenhuma das grades existentes muda de comportamento.

                      O nome é `cabecalho-<datafield>`, no mesmo espírito do slot de célula (que é
                      só `<datafield>`) — o prefixo evita colidir com ele.
                    -->
                    <slot :name="`cabecalho-${column.datafield}`" :column="column">{{ column.text
                      }}</slot>
                    <span><button type="button" class="btn btn-link p-0 border-0 align-baseline"
                        style="background: transparent" @click="sortResult(column.datafield)"
                        v-if="$props.useColumnSort && colunaOrdenavel(column)"
                        :title="rotuloBotaoOrdenar(column)"
                        :aria-label="rotuloBotaoOrdenar(column)"><i
                          class="mdi mdi-order-alphabetical-ascending text-success"
                          aria-hidden="true"></i></button></span>
                    <!-- Só aparece na coluna que está ordenando: desfaz a ordenação dela e devolve
                         a listagem à ordem padrão da tela. -->
                    <span v-if="$props.useColumnSort && colunaOrdenada(column.datafield)"><button
                        type="button" class="btn btn-link p-0 border-0 align-baseline"
                        style="background: transparent"
                        @click="removerOrdenacao(column.datafield)"
                        :title="`Remover a ordenação por ${column.text}`"
                        :aria-label="`Remover a ordenação por ${column.text}`"><i
                          class="mdi mdi-close text-danger consulte-grid-remover-ordenacao"
                          aria-hidden="true"></i></button></span>
                    <!--
                      A alça de redimensionar só respondia a `mousedown`: era anunciada
                      como separador com rótulo "Redimensionar coluna X", mas não havia
                      como acioná-la sem mouse. Agora é um `separator` focável que se
                      opera com as setas ← →  (e Home/End para mínimo/padrão), seguindo o
                      padrão ARIA de window splitter (`aria-valuenow` em pixels).
                    -->
                    <span class="col-resize-handle" role="separator" aria-orientation="vertical"
                      tabindex="0"
                      :aria-label="`Redimensionar coluna ${column.text}`"
                      :aria-valuenow="Math.round(larguraAtualColuna(column))"
                      :aria-valuemin="LARGURA_MINIMA_COLUNA"
                      :aria-valuemax="LARGURA_MAXIMA_COLUNA"
                      :aria-valuetext="`${Math.round(larguraAtualColuna(column))} pixels`"
                      @mousedown="iniciarResizeColuna(column, $event)"
                      @keydown="redimensionarPorTeclado(column, $event)"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- `colspan="100%"` não existe no HTML: o atributo aceita só número, e
                     o valor inválido faz a célula valer 1 coluna — a mensagem "Nenhum
                     resultado" ficava presa na primeira coluna. `totalDeColunas` calcula
                     o número real, contando as colunas de apoio (seleção, ações...). -->
                <tr v-if="dataSource?.loading">
                  <!--
                    O `role="status"` estava no <td>: um `role` SUBSTITUI o papel nativo do
                    elemento, então a célula deixava de ser célula e a linha ficava com um
                    filho que a tabela não reconhece — a estrutura da tabela quebrava para o
                    leitor de tela justamente durante o carregamento.

                    A região viva do componente (no fim do template) já anuncia o resultado
                    da consulta; aqui basta o texto alternativo do indicador visual.
                  -->
                  <td :colspan="totalDeColunas" style="height: 52.6px; padding-top: 10px">
                    <div class="spinner-border text-primary" style="position: absolute; left: 46%" aria-hidden="true"></div>
                    <span class="apenas-leitor-tela">Carregando registros...</span>
                  </td>
                </tr>

                <tr v-if="!dataSource?.loading && (dataSource?.rows?.length ?? 0) == 0">
                  <td :colspan="totalDeColunas"><i>Nenhum resultado</i></td>
                </tr>

                <slot name="body">
                  <tr v-for="(row, indexRow) in dataSource?.rows" :key="(row as any)" :class="row._rowClass">
                    <td v-if="selectable">
                      <!-- Sem rótulo, cada caixa da coluna era anunciada apenas como
                           "caixa de seleção" — em 50 linhas iguais, sem dizer qual linha. -->
                      <input type="checkbox" @change="onChangeSelection" :value="row" v-model="rowsSelected"
                        class="form-check-input" :aria-label="rotuloSelecaoLinha(row, indexRow)" />
                    </td>
                    <td v-if="rowDetails">
                      <button title="Detalhes da linha" @click="
                        () => {
                          row.details = !row.details;
                          console.log(row.details);
                        }
                      " type="button" style="background-color: transparent; border-color: transparent" class="btn btn-link p-0 border-0 align-baseline "
                      aria-label="Detalhes da linha">
                        <i style="font-size: 17px; color: #a1a09f" class="uil" :class="{
                          'uil-angle-down': row.details == true,
                          'uil-angle-right': !row.details,
                        }"
                        aria-hidden="true"></i>
                      </button>
                    </td>

                    <td v-if="actions" :class="{ 'fixed-side': useFreezedColumn() }">
                      <slot name="actions" :row="row" :index="indexRow"> </slot>
                    </td>
                    <td v-if="buttonClickSave" class="text-center" style="width: 200px">
                      <button title="Salvar dados da linha" @click="onChangeDataRow(row, $event, indexRow)"
                        class="btn btn-sm btn-success" style="margin-right: 5px"
                        aria-label="Salvar dados da linha">
                        <i class="mdi mdi-floppy" aria-hidden="true"></i>
                      </button>

                      <span class="text-danger font-16" :id="gerarIdComponente(
                        `spanEmptyTextArea${$props.idDivPaiConsulteGrid}`,
                        indexRow,
                        0
                      )
                        " style="display: none">
                        <hr />
                        * Clique no botão para salvar!
                      </span>
                    </td>

                    <!--
                      Célula que vira <th scope="row"> quando é o CABEÇALHO DE LINHA (a coluna
                      que identifica o registro): é o que dá contexto de linha ao leitor de tela,
                      que sem isso lê "coluna X: valor" sem dizer de qual registro. Só o tag muda
                      (via <component :is>); atributos e conteúdo seguem idênticos. O <th> tem o
                      peso da fonte e o alinhamento normalizados para não destoar das demais
                      células (o padrão do navegador para th é negrito e centralizado).
                    -->
                    <component :is="ehCabecalhoDeLinha(column, row) ? 'th' : 'td'"
                      :scope="ehCabecalhoDeLinha(column, row) ? 'row' : undefined"
                      v-for="(column, index) in (!row.details ? columnsData : new Array<ConsulteGridColumnsModel>)"
                      :key="index" :colspan="row.details ? columnsData?.length : 1" :hidden="column.hidden"
                      :class="{ 'fixed-side': column.freezedcolumn }"
                      :style="[getColumnStyle(column), ehCabecalhoDeLinha(column, row) ? { fontWeight: 'normal', textAlign: 'inherit' } : null]">
                      <!-- Infelizmente eh gambiarra, mas eh a unica forma -->
                      <div class="row" v-if="row.details">
                        <table class="table mb-1 table-centered table-nowrap">
                          <tbody>
                            <tr>
                              <td></td>

                              <td v-for="(columnDetails, index) in columnsData" :key="index">
                                <slot :name="columnDetails.datafield" :row="row">
                                  <div v-if="columnDetails.cellsrenderer" v-html="columnDetails.cellsrenderer(
                                    index,
                                    columnDetails.datafield,
                                    (row as any)[columnDetails.datafield]
                                  )
                                    "></div>
                                  <div v-if="!columnDetails.cellsrenderer && !columnDetails.columntype">
                                    {{ (row as any)[columnDetails.datafield] }}
                                  </div>

                                  <div class="form-check" v-if="
                                    columnDetails.columntype &&
                                    columnDetails.columntype == 'checkbox'
                                  ">
                                    <label class="form-check-label">
                                      <input class="form-check-input" type="checkbox"
                                        v-model="(row as any)[columnDetails.datafield]" disabled />
                                      <span class="form-check-sign"></span>
                                    </label>
                                  </div>
                                  <div v-if="
                                    columnDetails.columntype && columnDetails.columntype == 'date'
                                  ">
                                    {{
                                      new Date(
                                        (row as any)[columnDetails.datafield]
                                      ).toLocaleDateString()
                                    }}
                                  </div>
                                  <div v-if="
                                    columnDetails.columntype &&
                                    columnDetails.columntype == 'datetime'
                                  ">
                                    {{
                                      (row as any)[columnDetails.datafield]
                                        ? moment(
                                          new Date((row as any)[columnDetails.datafield])
                                        ).format('DD/MM/yyyy HH:mm')
                                        : ''
                                    }}
                                  </div>
                                </slot>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <slot name="rowDetails" :row="row" v-if="row.details"> </slot>

                      <div v-if="!row.details">
                        <slot v-if="!row.details" :name="(column as ConsulteGridColumnsModel).datafield" :row="row">
                          <div v-if="column.cellsrenderer" v-html="column.cellsrenderer(
                            index,
                            column.datafield,
                            (row as any)[column.datafield]
                          )
                            "></div>

                          <div
                            v-if="!column.cellsrenderer && !column.columntype && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)">
                            {{ (row as any)[column.datafield] }}
                          </div>

                          <div
                            v-if="!column.cellsrenderer && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) == 'number'">
                            <input style="min-width: 80px"
                              :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                              @change="
                                buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)
                                " type="number" v-model="(row as any)[column.datafield]" :aria-label="column.text" class="form-control" />
                          </div>

                          <div
                            v-if="!column.cellsrenderer && column.editinputdefinition == undefined && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) != 'number'">
                            <input
                              :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                              @change="
                                buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)
                                " type="text" v-model="(row as any)[column.datafield]" :aria-label="column.text" class="form-control" />
                          </div>
                          <div
                            v-if="!column.cellsrenderer &&
                              ((typeof column.editinputdefinition === 'object' && (column.editinputdefinition as any).type == 'textarea') || typeof column.editinputdefinition === 'string' && column.editinputdefinition == 'textarea')
                              && !column.columntype && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true) && (typeof (row as any)[column.datafield]) != 'number'">
                            <textarea :id="gerarIdComponente(
                              `textarea${$props.idDivPaiConsulteGrid}`,
                              indexRow,
                              index
                            )
                              "
                              :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                              @change="
                                buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)
                                " @input="
                                  handleInputTextAreaChange(
                                    `textarea${$props.idDivPaiConsulteGrid}`,
                                    indexRow,
                                    index,
                                    gerarIdComponente(
                                      `spanEmptyTextArea${$props.idDivPaiConsulteGrid}`,
                                      indexRow,
                                      0
                                    )
                                  )
                                  "
                              :rows="(typeof column.editinputdefinition === 'object') ? ((column.editinputdefinition as any)?.rows ?? 1) : 1"
                              v-model="(row as any)[column.datafield]" :aria-label="column.text" class="form-control"></textarea>
                          </div>

                          <div
                            v-if="column.columntype && column.columntype == 'number' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)">
                            <input
                              :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                              @change="
                                buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)
                                " type="number" v-model="(row as any)[column.datafield]" :aria-label="column.text" class="form-control"
                              style="min-width: 70px" />
                          </div>

                          <div class="form-check" v-if="column.columntype && column.columntype == 'checkbox'">
                            <label class="form-check-label">
                              <!--
                              Mesmo caso da coluna de data: o `!column.editable ||` à esquerda
                              garante que aqui editable é truthy, então a comparação com false
                              era sempre falsa (TS2367).
                              -->
                              <input @change="
                                buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)
                                " class="form-check-input" type="checkbox" v-model="(row as any)[column.datafield]" :aria-label="column.text"
                                :disabled="!column.editable || (typeof column.editable === 'function' ? !column.editable((row as any)) : false)" />
                              <span class="form-check-sign"></span>
                            </label>
                          </div>
                          <div v-if="column.columntype && column.columntype == 'date' && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                          ">
                            {{ new Date((row as any)[column.datafield]).toLocaleDateString() }}
                          </div>
                          <div v-if="column.columntype && column.columntype == 'date' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                          ">
                            <input
                              :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)"
                              @change="
                                buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)
                                " class="form-control" type="date" v-model="(row as any)[column.datafield]" :aria-label="column.text" />
                          </div>

                          <div v-if="column.columntype && column.columntype == 'datetime' && !(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                          ">
                            {{
                              (row as any)[column.datafield]
                                ? moment(new Date((row as any)[column.datafield])).format(
                                  'DD/MM/yyyy HH:mm'
                                )
                                : ''
                            }}
                          </div>
                          <div v-if="column.columntype && column.columntype == 'datetime' && (typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == true)
                          ">
                            <input
                              :disabled="(typeof column.editable === 'function' ? !column.editable((row as any)) : column.editable == false)"
                              @change="
                                buttonClickSave ? () => { } : onChangeDataRow(row as any, $event)
                                " class="form-control" type="datetime-local"
                              v-model="(row as any)[column.datafield]" :aria-label="column.text" />
                          </div>
                        </slot>
                      </div>
                    </component>
                    <!-- <slot name="rowDetail" v-if="rowDetails && row.details" :row="row">

                    <div class="card">
                      <div class="card-body">
                        teste
                      </div>
                    </div>

                </slot> -->
                  </tr>
                </slot>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="!singlePage" class="grid-footer">
          <!-- O rótulo era o texto de exemplo da documentação do Bootstrap
               ("Page navigation example"), lido em voz alta em toda listagem. -->
          <nav aria-label="Paginação da listagem">
            <ul class="pagination pagination-rounded">
              <li class="paginate_button page-item">
                <button type="button" class="page-link" :disabled="dataSource!.pageNumber == 0" @click="goToPage(0)"
                  aria-label="Primeira página"><i class="mdi mdi-chevron-double-left" aria-hidden="true"></i></button>
              </li>
              <li class="paginate_button page-item previous">
                <button type="button" class="page-link" :disabled="dataSource!.pageNumber == 0" @click="prev()"
                  aria-label="Página anterior"><i class="mdi mdi-chevron-left" aria-hidden="true"></i></button>
              </li>
              <li class="paginate_button page-item" v-bind:class="{ active: dataSource!.pageNumber + 1 == page }"
                v-for="page in arrayPages" :key="(page as number)">
                <button type="button" class="page-link" @click="goToPage((page as number) - 1)"
                  :aria-current="dataSource!.pageNumber + 1 == page ? 'page' : undefined"
                  :aria-label="`Página ${page}`">{{ page }}</button>
              </li>
              <li class="paginate_button page-item next">
                <button type="button" class="page-link"
                  :disabled="dataSource!.pageNumber >= (dataSource!.numberOfPages - 1)" @click="next()"
                  aria-label="Próxima página"><i class="mdi mdi-chevron-right" aria-hidden="true"></i></button>
              </li>
              <li class="paginate_button page-item">
                <button type="button" class="page-link"
                  :disabled="dataSource!.pageNumber >= (dataSource!.numberOfPages - 1)"
                  @click="goToPage(dataSource!.numberOfPages - 1)" aria-label="Última página"><i
                    class="mdi mdi-chevron-double-right" aria-hidden="true"></i></button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <!--
        Região viva com o resultado da consulta. Quem enxerga percebe a grade mudar; sem
        isto, quem usa leitor de tela filtra, ordena ou troca de página e não recebe
        retorno nenhum — a tela parece não ter reagido.

        `polite` para não interromper a leitura em curso, e `aria-atomic` para a frase
        ser lida inteira a cada mudança, em vez de só a parte que mudou.
      -->
      <p class="regiao-anuncio" role="status" aria-live="polite" aria-atomic="true">
        {{ anuncioDoResultado }}
      </p>
    </div>
  </div>
</template>
<script lang="ts">
import dialogoService from '@/services/globals/dialogo.service';
import { ConsulteGridColumnsModel, DataSource } from '@/datasources/consulte-grid';
import { GridActionTypes } from '@/store/grid/action-types';
import ConsulteGridFilters from '@/components/grid/ConsulteGridFilters.vue';
import ConsulteGridColumnSelection from '@/components/grid/ConsulteGridColumnSelection.vue';
import ConsulteGridViews from '@/components/grid/ConsulteGridViews.vue';
import { defineComponent, markRaw } from 'vue';
import { mapActions } from 'vuex';
import moment from 'moment';
import eventBus from '@/services/globals/events-bus.service';
import anuncioNavegacaoService from '@/services/globals/anuncio-navegacao.service';
import { MD5 } from 'crypto-js';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; // Importa corretamente a extensão autoTable
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default defineComponent({
  name: 'ConsulteGrid',
  emits: ['onChangeSelection', 'onChangeDataRow'],
  components: { ConsulteGridFilters, ConsulteGridColumnSelection, ConsulteGridViews },

  async mounted() {
    /*
     * Era `window.onresize = () => …`, ou seja, ATRIBUIÇÃO à propriedade: cada grade
     * montada apagava o handler da anterior, e nada removia o handler ao desmontar.
     *
     * Consequências reais:
     *   - com duas grades na mesma tela, só a última reagia ao redimensionamento — a
     *     primeira ficava presa no layout que tinha ao montar e não trocava para o
     *     formato de cartão do celular (`windowWidth <= 600`);
     *   - a mesma coisa acontecia ao ampliar o zoom, que é o caminho de quem tem baixa
     *     visão: a 400% a largura efetiva cai para a faixa do celular e a grade deveria
     *     mudar de formato (WCAG 1.4.10 Refluxo);
     *   - o handler sobrevivia à troca de tela, segurando o componente desmontado.
     *
     * `addEventListener` + remoção no `beforeUnmount` resolvem os três.
     */
    window.addEventListener('resize', this.aoRedimensionarJanela);
    eventBus.on('gridLoaded', () => {
      this.removerTabelaAuxiliarFreezedColumn();
      this.aplicarFreezedColumn();

      // A tabela só existe depois da carga, e é ela que precisa ser observada para a barra
      // espelhada acompanhar a largura do conteúdo.
      this.observarRolagem();
    });

    await this.aplicarLargurasColunasSalvas();

    this.observarRolagem();
  },

  beforeUnmount() {
    this.observadorRolagem?.disconnect();
    window.removeEventListener('resize', this.aoRedimensionarJanela);
  },

  data() {
    return {
      data: [],
      sortFields: [] as string[],
      loading: false,
      windowWidth: window.innerWidth,
      rowsSelected: [] as any[],
      moment: moment,
      columnsData: this.columns,
      idFilters: new Date().getTime() * 10000 + 621355968000000000,
      idColumns: new Date().getTime() * 10000 + 621455968000000000,
      /** Largura do conteúdo da grade — dimensiona o trilho da barra de rolagem superior. */
      larguraDoConteudo: 0,
      /** Largura visível da área de rolagem; abaixo dela não há o que rolar. */
      larguraVisivel: 0,
      /** Trava o eco entre as duas barras enquanto uma comanda a outra. */
      sincronizandoRolagem: false,
      observadorRolagem: null as ResizeObserver | null,
      /** Área rolável já resolvida, para não reler estilo computado a cada evento de rolagem. */
      areaRolagemAtual: null as HTMLElement | null,
      /**
       * Largura mínima de coluna, em pixels. Era uma constante local dentro de
       * `iniciarResizeColuna`; subiu para o estado porque o redimensionamento por
       * teclado e o `aria-valuemin` da alça precisam do mesmo valor — duas cópias
       * sairiam de sincronia na primeira vez que alguém mudasse uma delas.
       */
      LARGURA_MINIMA_COLUNA: 40,
      /**
       * Largura máxima de coluna, em pixels.
       *
       * Existe por causa do `aria-valuemax` da alça de redimensionar: o padrão ARIA para
       * um `separator` focável assume 0..100 quando `aria-valuemax` está ausente, e a
       * alça informa `aria-valuenow` em PIXELS. Sem o máximo, o leitor de tela recebia
       * "250 de 100" — valor fora da faixa, que alguns leitores traduzem para uma
       * porcentagem sem sentido.
       */
      LARGURA_MAXIMA_COLUNA: 1200,
    };
  },
  computed: {
    /** Espelhar a barra só faz sentido quando a grade transborda a área visível. */
    precisaRolagemHorizontal(): boolean {
      return this.larguraDoConteudo > this.larguraVisivel + 1;
    },

    /**
     * Número real de colunas da grade, contando as de apoio (seleção, detalhes, ações,
     * salvar). Serve ao `colspan` das linhas de "carregando" e "nenhum resultado", que
     * usavam `colspan="100%"` — valor inválido no HTML, então a célula valia 1 coluna e
     * a mensagem ficava presa na primeira.
     */
    totalDeColunas(): number {
      const colunasDeApoio =
        (this.selectable ? 1 : 0) +
        (this.rowDetails ? 1 : 0) +
        (this.actions ? 1 : 0) +
        (this.buttonClickSave ? 1 : 0);

      const colunasVisiveis = (this.columnsData ?? []).filter((coluna) => !coluna.hidden).length;

      return Math.max(1, colunasDeApoio + colunasVisiveis);
    },

    /**
     * Datafield da coluna que serve de CABEÇALHO DE LINHA (`<th scope="row">`).
     *
     * Sem uma âncora de linha, ao navegar célula a célula o leitor de tela lê "coluna X:
     * valor" mas nunca diz a QUE registro a linha pertence — foi o que motivou isto. A
     * coluna escolhida vira o `<th scope="row">` que o NVDA repete como contexto ao ler as
     * outras células da linha.
     *
     * Escolha: a coluna marcada com `rowheader`; se nenhuma marcar, a primeira coluna
     * visível FILTRÁVEL — heurística para pular colunas de controle (botão Editar, ícone),
     * que por convenção nesta base vêm com `filterable: false`. Não achando nenhuma, fica
     * `undefined` e as células seguem como `<td>` (comportamento atual, nada muda).
     */
    datafieldCabecalhoLinha(): string | undefined {
      const colunas = this.columnsData ?? [];
      const marcada = colunas.find((c) => c.rowheader && !c.hidden);
      if (marcada) return marcada.datafield;
      const primeiraFiltravel = colunas.find((c) => !c.hidden && c.filterable !== false);
      return primeiraFiltravel?.datafield;
    },

    /**
     * Texto da região viva da grade. Quem enxerga percebe a listagem mudar; sem este
     * anúncio, filtrar/ordenar/paginar não dá retorno nenhum a quem usa leitor de tela.
     *
     * Devolve string vazia durante o carregamento de propósito: anunciar "0 registros"
     * no meio da requisição e "48 registros" logo depois faria o leitor falar duas
     * vezes, sendo a primeira informação falsa.
     */
    anuncioDoResultado(): string {
      if (!this.dataSource || this.dataSource.loading) return '';

      const total = this.dataSource.rows?.length ?? 0;
      if (total === 0) return 'Nenhum registro encontrado.';

      const paginas = this.dataSource.numberOfPages ?? 1;
      const registros = total === 1 ? '1 registro encontrado' : `${total} registros encontrados`;

      if (this.singlePage || paginas <= 1) return `${registros}.`;

      return `${registros}. Página ${this.dataSource.pageNumber + 1} de ${paginas}.`;
    },

    arrayPages: function () {
      let array: Number[] = [];
      let added = 0;
      let add = (x: Number) => {
        array.push(x);
        added++;
      };
      this.dataSource!.calculateNumberOfPages();
      let pages = this.dataSource!.numberOfPages;
      let atual = this.dataSource!.pageNumber + 1;
      if (atual > 4 && atual == pages) add(atual - 4);
      if (atual > 3 && atual + 2 > pages) add(atual - 3);
      if (atual > 2) add(atual - 2);
      if (atual > 1) add(atual - 1);
      add(atual++);
      while (added < 5 && atual <= pages) add(atual++);

      return array;
    },
  },
  methods: {
    /**
     * Reage ao redimensionamento da janela — inclusive à mudança de zoom, que é o que
     * altera a largura efetiva para quem usa ampliação. É ele que faz a grade alternar
     * entre a tabela e o layout de cartão (`windowWidth <= 600`).
     *
     * Método nomeado (e não função anônima) porque `removeEventListener` precisa da
     * MESMA referência que foi registrada — com arrow function inline, a remoção no
     * `beforeUnmount` não removeria nada.
     */
    aoRedimensionarJanela(): void {
      this.windowWidth = window.innerWidth;
    },
    ...mapActions([
      GridActionTypes.CLEAR_GRID,
      GridActionTypes.SET_FILTER,
      GridActionTypes.SET_ORDER,
      GridActionTypes.SET_ORDER,
      GridActionTypes.SET_PAGE,
      GridActionTypes.CLEAR_FILTERS,
      GridActionTypes.CLEAR_ORDER,
      GridActionTypes.CLEAR_PAGE,
      GridActionTypes.GET_GRID,
      GridActionTypes.SET_COLUMN_WIDTH,
    ]),
    getColumnStyle(column: ConsulteGridColumnsModel) {
      if (!column.width) return undefined;
      return {
        width: `${column.width}px`,
        minWidth: `${column.width}px`,
        maxWidth: `${column.width}px`,
        whiteSpace: 'normal',
        overflow: 'hidden',
      };
    },
    /**
     * Esta célula é o cabeçalho de linha (vira `<th scope="row">`)? Só na renderização
     * normal da linha — em modo `details` a célula assume um colspan e outro conteúdo, e
     * ali não faz sentido ser cabeçalho.
     */
    ehCabecalhoDeLinha(column: ConsulteGridColumnsModel, row: any): boolean {
      return !row?.details && column.datafield === this.datafieldCabecalhoLinha;
    },
    async aplicarLargurasColunasSalvas() {
      if (!this.$route.name || !this.columnsData) return;

      const gridState = await this[GridActionTypes.GET_GRID](this.$route.name as string);
      const columnWidths = gridState?.columnWidths;
      if (!columnWidths) return;

      this.columnsData.forEach((column) => {
        const largura = columnWidths[column.datafield];
        if (typeof largura === 'number') column.width = largura;
      });
    },
    iniciarResizeColuna(column: ConsulteGridColumnsModel, event: MouseEvent) {
      event.preventDefault();
      const th = (event.target as HTMLElement).closest('th');
      if (!th) return;

      // A mínima vem do estado (LARGURA_MINIMA_COLUNA): o mesmo valor alimenta o
      // redimensionamento por teclado e o `aria-valuemin` da alça.
      const startX = event.clientX;
      const startWidth = column.width ?? th.getBoundingClientRect().width;

      const aoMover = (moveEvent: MouseEvent) => {
        column.width = Math.max(
          this.LARGURA_MINIMA_COLUNA,
          startWidth + (moveEvent.clientX - startX)
        );
      };

      const aoSoltar = () => {
        document.removeEventListener('mousemove', aoMover);
        document.removeEventListener('mouseup', aoSoltar);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';

        if (this.$route.name && column.width) {
          this[GridActionTypes.SET_COLUMN_WIDTH]({
            grid: this.$route.name as string,
            datafield: column.datafield,
            width: column.width,
          });
        }

        if (this.useFreezedColumn()) {
          this.removerTabelaAuxiliarFreezedColumn();
          this.aplicarFreezedColumn();
        }
      };

      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
      document.addEventListener('mousemove', aoMover);
      document.addEventListener('mouseup', aoSoltar);
    },
    toJson(data: any) {
      return JSON.stringify(data);
    },
    next() {
      this.dataSource?.next();
    },
    prev() {
      this.dataSource?.prev();
    },
    goToPage(page: number) {
      this.dataSource?.goToPage(page);
    },
    getColumnByDataField(datafield: string) {
      return this.columnsData?.find((x) => x.datafield == datafield);
    },

    onChangeSelection() {
      if (this.singleSelection) {
        let last = null;
        if (this.rowsSelected.length > 0) {
          last = this.rowsSelected[this.rowsSelected.length - 1];
          this.rowsSelected = [last];
        }

        this.$emit('onChangeSelection', last ? this.rowsSelected[0] : null);
      } else this.$emit('onChangeSelection', this.rowsSelected);
    },
    /**
     * `indexRow` é OPCIONAL: dos dezesseis pontos que chamam este método no template,
     * só o botão de salvar da tabela desktop passa o índice — os campos editáveis e o
     * botão da versão mobile chamam com dois argumentos. O parâmetro foi acrescentado
     * depois, junto do aviso de pendência de gravação, e esses pontos nunca foram
     * atualizados; como era obrigatório, o type-checker do build acusava
     * "An argument for 'indexRow' was not provided" em cada um deles.
     *
     * `?` em vez de `= null` de propósito: omitido, o valor continua sendo `undefined`,
     * exatamente como já chegava em tempo de execução. Um default `null` mudaria o
     * seletor montado em limparAvisoPendenciaGravacao (`..._undefined` viraria
     * `..._null`) — nenhum dos dois casa com id real, mas não é hora de mudar isso de
     * carona numa correção de tipo.
     */
    onChangeDataRow(row: any, event: any, indexRow?: any) {
      this.$emit('onChangeDataRow', event.target.value, row);
      this.limparAvisoPendenciaGravacao(indexRow);
    },
    limparAvisoPendenciaGravacao(indexRow: any) {
      try {
        const textArea = document.querySelectorAll(
          `[id^='textarea${this.$props.idDivPaiConsulteGrid}_${indexRow}']`
        );
        textArea.forEach((item) => {
          (item as HTMLElement).style.backgroundColor = '#fff';
          (item as HTMLElement).style.color = '#6c757d';
        });

        const spanEmptyTextArea = document.querySelectorAll(
          `[id^='spanEmptyTextArea${this.$props.idDivPaiConsulteGrid}_${indexRow}_0']`
        )[0];
        (spanEmptyTextArea as HTMLElement).style.display = 'none';
      } catch {
        console.log('Erro ao limpar style no grid de aviso de pendência de gravação');
      }
    },
    useFreezedColumn(): Boolean {
      return this.columnsData?.some((x) => x.freezedcolumn) ?? false;
    },
    imprimirExportar(type: string) {
      const tabelaId = 'tabelaConsulteGrid'; // ID da sua tabela
      const nomeArquivoRelatorio = `${this.$props.nomeArquivoRelatorio}_${moment().format(
        'DDMMYYYYHHmmss'
      )}`;
      const tituloRelatorio = this.$props.tituloRelatorio;
      switch (type) {
        case 'PDF':
          this.gerarPDF(tabelaId, nomeArquivoRelatorio, tituloRelatorio);
          break;
        case 'HTML':
          this.gerarHTML(tabelaId, nomeArquivoRelatorio);
          break;
        case 'XLSX':
          this.gerarXLS(tabelaId, nomeArquivoRelatorio, tituloRelatorio);
          break;
        case 'DOC':
          this.gerarDOC(tabelaId, nomeArquivoRelatorio);
          break;
        case 'PÁGINA':
          window.print();
          break;
      }
    },
    gerarPDF(idTabela: string, nomeArquivoRelatorio: string, tituloRelatorio: string) {
      const tabela = document.getElementById(idTabela) as HTMLTableElement;
      if (!tabela) {
        dialogoService.avisar({ mensagem: 'Tabela não encontrada!', tom: 'erro' });
        return;
      }

      const pdf = new jsPDF();
      pdf.text(tituloRelatorio, 14, 10);

      // Chama autoTable corretamente
      autoTable(pdf, { html: `#${idTabela}` });

      nomeArquivoRelatorio = nomeArquivoRelatorio + '.pdf';
      pdf.save(nomeArquivoRelatorio);
    },
    gerarHTML(idTabela: string, nomeArquivoRelatorio: string) {
      const tabela = document.getElementById(idTabela)?.outerHTML;
      if (!tabela) return;

      const blob = new Blob([tabela], { type: 'text/html' });
      nomeArquivoRelatorio = nomeArquivoRelatorio + '.html';
      saveAs(blob, nomeArquivoRelatorio);
    },
    gerarXLS(idTabela: string, nomeArquivoRelatorio: string, tituloRelatorio: string) {
      const tabela = document.getElementById(idTabela) as HTMLTableElement;
      if (!tabela) {
        dialogoService.avisar({ mensagem: 'Tabela não encontrada!', tom: 'erro' });
        return;
      }

      const ws = XLSX.utils.table_to_sheet(tabela);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, tituloRelatorio);

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      nomeArquivoRelatorio = nomeArquivoRelatorio + '.xlsx';

      saveAs(data, nomeArquivoRelatorio);
    },
    gerarDOC(idTabela: string, nomeArquivoRelatorio: string) {
      const tabela = document.getElementById(idTabela)?.outerHTML;
      if (!tabela) return;

      // Cria um arquivo DOC
      const docContent = `
        <html xmlns:w="urn:schemas-microsoft-com:office:word">
          <head>
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
            <style>
              table { border: 1px solid black; border-collapse: collapse; }
              table th, table td { padding: 5px; border: 1px solid black; }
            </style>
          </head>
          <body>
            <table>${tabela}</table>
          </body>
        </html>
      `;

      const blob = new Blob([docContent], { type: 'application/msword' });
      nomeArquivoRelatorio = nomeArquivoRelatorio + '.doc';
      saveAs(blob, nomeArquivoRelatorio);
    },
    /**
     * O nome do campo dentro de uma entrada de `sortFields` ("nome ASC" -> "nome"). Comparar o
     * nome inteiro, e não por prefixo, evita que "nome" seja confundido com "nomeEstudante".
     */
    campoDaOrdenacao(entrada: string): string {
      return (entrada ?? '').split(' ')[0];
    },
    /**
     * Valor de `aria-sort` do cabeçalho: 'ascending', 'descending' ou 'none'.
     *
     * É o único jeito de o leitor de tela saber que a coluna está ordenada e em que
     * sentido — a informação hoje só existia visualmente (na tarja de texto acima da
     * grade). `undefined` nas colunas que não participam da ordenação, para não
     * declarar `aria-sort="none"` em coluna que nem é ordenável.
     */
    // Retorno tipado com os valores LITERAIS, e não `string`: o `aria-sort` do
    // ThHTMLAttributes aceita só 'none' | 'ascending' | 'descending' | 'other', e um
    // `string` genérico era recusado (TS2322) — o próprio compilador cobre agora um
    // erro de digitação num desses valores, que antes passaria calado.
    direcaoOrdenacaoAria(
      column: ConsulteGridColumnsModel
    ): 'none' | 'ascending' | 'descending' | undefined {
      // Coluna que não é ordenável não declara `aria-sort` — nem mesmo 'none', que
      // anunciaria ao leitor de tela uma ordenação disponível que não existe. Era o
      // que acontecia com as colunas de botão ("Selecionar") e com toda coluna não
      // filtrável, contra a intenção descrita acima.
      if (!this.useColumnSort || !this.colunaOrdenavel(column)) return undefined;

      const entrada = this.sortFields.find(
        (campo: string) => this.campoDaOrdenacao(campo) === column.datafield
      );

      if (!entrada) return 'none';
      return entrada.endsWith('DESC') ? 'descending' : 'ascending';
    },
    /**
     * Se a coluna aceita ordenação. `sortable` manda; sem ele, vale `filterable`, que
     * era o critério único antes de `sortable` existir — assim nenhuma grade que não
     * declara o novo campo muda de comportamento.
     */
    colunaOrdenavel(column: ConsulteGridColumnsModel): boolean {
      return column.sortable ?? column.filterable ?? false;
    },
    /**
     * Rótulo do botão de ordenar dizendo o que o clique VAI fazer, e não apenas
     * "Ordenar por X": o mesmo botão alterna crescente → decrescente, e sem isso o
     * usuário de leitor de tela não tem como prever nem confirmar o resultado.
     */
    rotuloBotaoOrdenar(column: ConsulteGridColumnsModel): string {
      const direcao = this.direcaoOrdenacaoAria(column);

      if (direcao === 'ascending') {
        return `Ordenar por ${column.text} em ordem decrescente (atualmente crescente)`;
      }
      if (direcao === 'descending') {
        return `Ordenar por ${column.text} em ordem crescente (atualmente decrescente)`;
      }
      return `Ordenar por ${column.text} em ordem crescente`;
    },
    /**
     * Rótulo da caixa de seleção da linha. Usa a primeira coluna visível com texto como
     * identificação ("Selecionar MARIA DA SILVA"), porque é o que o usuário vê como
     * identidade da linha. Se não houver nada legível, cai no número da linha.
     */
    rotuloSelecaoLinha(row: any, indice: number): string {
      const primeiraColunaComTexto = this.columnsData?.find(
        (coluna) => !coluna.hidden && !!row?.[coluna.datafield]
      );

      const identificacao = primeiraColunaComTexto
        ? String(row[primeiraColunaComTexto.datafield])
        : `linha ${indice + 1}`;

      return `Selecionar ${identificacao}`;
    },
    /** Largura atual da coluna, para o `aria-valuenow` da alça de redimensionar. */
    larguraAtualColuna(column: ConsulteGridColumnsModel): number {
      if (column.width) return column.width;

      const th = document.querySelector<HTMLElement>(
        `#tabelaConsulteGrid th[data-datafield="${column.datafield}"]`
      );
      return th?.getBoundingClientRect().width ?? 0;
    },
    /**
     * Redimensiona a coluna pelo teclado, com a alça focada:
     *   ← →            10px por vez
     *   Shift + ← →    50px (ajuste grosso)
     *   Home           largura mínima
     *   End            solta a largura fixa (volta ao automático da tabela)
     *
     * Antes o redimensionamento existia só no `mousedown`: sem mouse (ou sem
     * conseguir arrastar com precisão) não havia como alargar uma coluna cortada.
     */
    redimensionarPorTeclado(column: ConsulteGridColumnsModel, event: KeyboardEvent) {
      const PASSO = event.shiftKey ? 50 : 10;
      const atual = this.larguraAtualColuna(column) || this.LARGURA_MINIMA_COLUNA;
      let nova: number | undefined;

      switch (event.key) {
        case 'ArrowRight':
          nova = atual + PASSO;
          break;
        case 'ArrowLeft':
          nova = Math.max(this.LARGURA_MINIMA_COLUNA, atual - PASSO);
          break;
        case 'Home':
          nova = this.LARGURA_MINIMA_COLUNA;
          break;
        case 'End':
          nova = undefined;
          break;
        default:
          return;
      }

      event.preventDefault();
      column.width = nova;

      if (this.$route.name) {
        this[GridActionTypes.SET_COLUMN_WIDTH]({
          grid: this.$route.name as string,
          datafield: column.datafield,
          width: nova ?? 0,
        });
      }

      if (this.useFreezedColumn()) {
        this.removerTabelaAuxiliarFreezedColumn();
        this.aplicarFreezedColumn();
      }
    },
    /** Se esta coluna está participando da ordenação — é o que faz o "x" aparecer. */
    colunaOrdenada(datafield: string): boolean {
      return this.sortFields.some(
        (entrada: string) => this.campoDaOrdenacao(entrada) === datafield
      );
    },
    /**
     * Tira UMA coluna da ordenação, preservando as demais. Sem nenhuma sobrando, a listagem
     * volta à ordem padrão da tela — que é o que o `setSortDataField('')` faz.
     */
    removerOrdenacao(datafield: string) {
      this.sortFields = this.sortFields.filter(
        (entrada: string) => this.campoDaOrdenacao(entrada) !== datafield
      );

      this.dataSource?.setSortDataField(this.sortFields.join(', '));
      this.dataSource?.load();
    },
    clearGridSort() {
      this.sortFields = [];
      this.dataSource?.setSortDataField('');
      this.dataSource?.load();
    },
    sortResult(datafield: string) {
      // Comparação pelo nome exato do campo: por prefixo, ordenar por "nome" reaproveitaria
      // (e sobrescreveria) uma ordenação já aplicada em "nomeEstudante".
      const existingIndex = this.sortFields.findIndex(
        (field) => this.campoDaOrdenacao(field) === datafield
      );

      if (existingIndex === -1) {
        // Se não existir, adiciona com 'ASC'
        this.sortFields.push(`${datafield} ASC`);
      } else {
        // Se existir, alterna entre 'ASC' e 'DESC'
        this.sortFields[existingIndex] = this.sortFields[existingIndex].endsWith('ASC')
          ? `${datafield} DESC`
          : `${datafield} ASC`;
      }

      const auxSortFields = this.sortFields.join(', ');
      this.dataSource?.setSortDataField(auxSortFields);
      this.dataSource?.load();
    },
    /**
     * Marca a célula como "alterada e ainda não salva".
     *
     * Três correções de acessibilidade, todas no mesmo estado:
     *
     * 1. WCAG 1.4.1 (uso da cor) — o aviso era o fundo rosa da célula MAIS o texto
     *    "* Clique no botão para salvar!" na coluna de salvar. Só que o texto ficava numa
     *    coluna diferente da célula alterada: quem não distingue o rosa não tinha como
     *    saber QUAL célula mudou. O `aria-describedby` amarra os dois.
     *
     * 2. WCAG 1.4.6 — o par #6a0210 sobre #ff95a3 dá 6,19:1, abaixo dos 7:1. O texto
     *    escureceu para #4a0009 (7,78:1) sobre o mesmo fundo.
     *
     * 3. WCAG 4.1.3 (mensagens de estado) — o texto só aparecia; nada era anunciado.
     *    Trocar `display` não é mudança de CONTEÚDO, então uma região viva ali não
     *    resolveria. O anúncio sai pela região permanente do App.vue, que é o padrão do
     *    projeto (ver docs/acessibilidade).
     *
     * O anúncio só sai na PRIMEIRA alteração da célula: a cada tecla digitada seria
     * repetido, e o leitor de tela ficaria interrompendo a própria digitação.
     */
    handleInputTextAreaChange(
      prefixo: any,
      indexRow: any,
      indexColumn: any,
      idSpanExibir: string = ''
    ) {
      let id = this.gerarIdComponente(prefixo, indexRow, indexColumn);
      let componente = document.getElementById(id);
      if (componente) {
        componente.style.backgroundColor = '#ff95a3';
        componente.style.color = '#4a0009';

        let componenteSpanExibir = document.getElementById(idSpanExibir);
        if (componenteSpanExibir) {
          const jaEstavaVisivel = componenteSpanExibir.style.display === 'inline';
          componenteSpanExibir.style.display = 'inline';

          // Liga o aviso ao campo alterado, preservando um describedby que já exista.
          const descricoes = (componente.getAttribute('aria-describedby') || '')
            .split(/\s+/)
            .filter(Boolean);
          if (!descricoes.includes(idSpanExibir)) {
            descricoes.push(idSpanExibir);
            componente.setAttribute('aria-describedby', descricoes.join(' '));
          }

          if (!jaEstavaVisivel) {
            anuncioNavegacaoService.anunciar(
              'Alteração pendente. Clique no botão salvar da linha para gravar.',
            );
          }
        }
      }
    },
    gerarIdComponente(prefixo: any, indexRow: any, indexColumn: any): string {
      let idComponente = indexRow.toString() + indexColumn.toString();
      let id =
        prefixo.toString() +
        '_' +
        indexRow +
        '_' +
        indexColumn +
        '_' +
        MD5(idComponente).toString();
      return id.toString();
    },
    async onSelectView(view: any) {
      this[GridActionTypes.SET_FILTER]({
        grid: this.$route.name as string,
        filters: view?.filters ?? [],
      });
      await this.$refs.componentFilter.loadFilters();

      this.columns?.forEach((x) => {
        const column = view
          ? view.columns?.find((y: any) => y.datafield == x.datafield)
          : this.columns?.find((y: any) => y.datafield == x.datafield);
        if (column) x.hidden = column.hidden;
      });

      if (!view) this.$refs.componentFilter.clearFilters();
      else this.$refs.componentFilter.filter();
    },
    /**
     * O elemento que REALMENTE rola na horizontal.
     *
     * Com coluna fixa é o `.table-wrap` de dentro; sem ela, o `.table-responsive` de fora. A
     * escolha é pelo `overflow-x` COMPUTADO, e não por "quem transborda": um div comum com uma
     * tabela larga dentro também tem `scrollWidth > clientWidth`, mas ignora `scrollLeft` e
     * devolve sempre 0 — a barra espelhada ficaria inerte nas grades sem coluna fixa.
     *
     * Ler o estilo em vez de repetir a condição de `useFreezedColumn()` também mantém a barra
     * correta no layout de celular, que troca a tabela por outra, fora do `.table-scroll`.
     */
    resolverAreaDeRolagem(): HTMLElement | null {
      const candidatos = [
        this.$refs.areaRolagemInterna as HTMLElement | undefined,
        this.$refs.areaRolagemExterna as HTMLElement | undefined,
      ];

      const rolavel = candidatos.find((elemento) => {
        if (!elemento) return false;

        const overflowX = window.getComputedStyle(elemento).overflowX;

        return overflowX === 'auto' || overflowX === 'scroll';
      });

      return rolavel ?? candidatos[1] ?? null;
    },

    /**
     * Mede o curso da barra espelhada: largura do conteúdo e largura visível.
     *
     * Reresolve a área a cada medição — é o observador de tamanho que chama isto, então cobre a
     * troca de layout (celular/desktop) sem um segundo gatilho. `markRaw` porque o elemento vai
     * para o `data` só como referência: envolvê-lo no proxy reativo do Vue não serve a nada aqui.
     */
    medirRolagem() {
      const area = this.resolverAreaDeRolagem();

      this.areaRolagemAtual = area ? markRaw(area) : null;
      this.larguraDoConteudo = area?.scrollWidth ?? 0;
      this.larguraVisivel = area?.clientWidth ?? 0;
    },

    /** Mantém as duas barras no mesmo ponto sem que uma dispare a outra em eco. */
    sincronizarRolagem(origem: 'superior' | 'area') {
      if (!this.barraRolagemSuperior || this.sincronizandoRolagem) return;

      const superior = this.$refs.rolagemSuperior as HTMLElement | undefined;
      const area = this.areaRolagemAtual ?? this.resolverAreaDeRolagem();

      if (!superior || !area) return;

      this.sincronizandoRolagem = true;

      if (origem === 'superior') area.scrollLeft = superior.scrollLeft;
      else superior.scrollLeft = area.scrollLeft;

      // A rolagem programática dispara um novo evento `scroll` no outro elemento; só liberar no
      // quadro seguinte, quando ele já foi consumido.
      requestAnimationFrame(() => {
        this.sincronizandoRolagem = false;
      });
    },

    /**
     * (Re)liga o observador que remede a grade. Chamado na montagem e a cada `gridLoaded`, porque
     * a tabela só passa a existir depois da carga dos dados.
     */
    observarRolagem() {
      if (!this.barraRolagemSuperior) return;

      this.observadorRolagem?.disconnect();
      this.observadorRolagem = null;

      this.medirRolagem();

      const area = this.areaRolagemAtual;

      if (!area || typeof ResizeObserver === 'undefined') return;

      const observador = markRaw(new ResizeObserver(() => this.medirRolagem()));

      // A área visível muda ao girar o tablet, redimensionar a janela ou recolher o menu lateral;
      // a tabela muda ao paginar, exibir/esconder colunas e redimensioná-las.
      observador.observe(area);
      area.querySelectorAll('table').forEach((tabela) => observador.observe(tabela));

      this.observadorRolagem = observador;
    },

    removerTabelaAuxiliarFreezedColumn() {
      const tables = document.querySelectorAll('table.main-table.fixed-table');
      tables.forEach((table) => table.remove());
    },
    aplicarFreezedColumn() {
      const table = document.querySelector('.main-table') as HTMLTableElement;
      if (table) {
        let clone = table.cloneNode(true) as HTMLTableElement;
        clone.className += ' fixed-table';
        let body = document.getElementById('table-scroll');
        if (body) {
          body.appendChild(clone);
        } else {
          //console.error("Elemento 'table-scroll' não encontrado.");
        }
      } else {
        //console.error("Elemento 'mainTable' não encontrado.");
      }
    },
  },
  props: {
    columns: {
      type: Object as () => Array<ConsulteGridColumnsModel>,
    },
    actions: { type: Boolean, default: () => false },
    /**
     * Ordenação por coluna no cabeçalho. Ligada por padrão: toda listagem do sistema deve poder
     * ser ordenada pelo usuário. Uma tela cujo conteúdo depende da ordem em que veio (matriz,
     * lançamento em lote) desliga com `:use-column-sort="false"`.
     *
     * O botão só aparece em coluna `filterable` — coluna de foto, de ações ou de checkbox não
     * tem o que ordenar.
     */
    useColumnSort: { type: Boolean, default: () => true },
    usePrinter: { type: Boolean, default: () => false },
    nomeArquivoRelatorio: { type: String, default: () => 'SAEWEB_Report' },
    tituloRelatorio: { type: String, default: () => 'SAEWEB_Report' },
    selectable: { type: Boolean, default: () => false },
    singleSelection: { type: Boolean, default: () => false },
    tituloActions: { type: String, default: () => '#' },
    dataSource: {
      type: Object as () => DataSource<any>,
    },
    idDivPaiConsulteGrid: {
      type: String,
      default: () => '',
    },
    hideHeader: {
      type: Boolean,
      default: () => false,
    },
    hideHeaderGrid: {
      type: Boolean,
      default: () => false,
    },
    onlySearchHeader: {
      type: Boolean,
      default: () => false,
    },
    buttonClickSave: {
      type: Boolean,
      default: () => false,
    },
    singlePage: {
      type: Boolean,
      default: () => false,
    },
    rowDetails: {
      type: Boolean,
      default: () => false,
    },
    /**
     * O seletor de "Visões" (conjuntos de colunas/filtros salvos pelo usuário). Desligado por
     * padrão: só faz sentido em listagem que o usuário realmente reconfigura, e em toda as
     * outras ele era mais um controle a ignorar no cabeçalho. A tela que quiser liga com
     * `:show-views-manager="true"`.
     */
    showViewsManager: {
      type: Boolean,
      default: () => false,
    },
    showFilterButton: {
      type: Boolean,
      default: () => true,
    },
    showColumnSelectionButton: {
      type: Boolean,
      default: () => true,
    },
    showAppliedFilters: {
      type: Boolean,
      default: () => true,
    },
    /**
     * Duplica a barra de rolagem horizontal ACIMA da grade.
     *
     * Opt-in, e não padrão: a barra extra só se paga em grade larga o bastante para exigir arrasto
     * (faltas, com uma coluna por dia de aula). Ligá-la em todas as 180+ grades acrescentaria um
     * ResizeObserver e uma faixa de 10px a telas que rolam de uma vez.
     */
    barraRolagemSuperior: {
      type: Boolean,
      default: () => false,
    },
  },
});
</script>
<style lang="scss">
.consulte-grid-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
}

/*
 * Barra de rolagem espelhada acima da grade (prop `barra-rolagem-superior`). Grudada no topo da
 * área visível para ser alcançável de qualquer ponto da listagem — a barra nativa mora no rodapé da
 * tabela, a dezenas de linhas de distância. O trilho de dentro recebe a largura do conteúdo por JS;
 * é ele que dá a esta barra o mesmo curso da de baixo.
 */
.consulte-grid-rolagem-superior {
  position: sticky;
  top: 0;
  z-index: 3;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: #f7f6f6;
  /* Barras sobrepostas (macOS/iOS) só aparecem durante a rolagem; sem forçar a barra aqui ninguém
     descobre que dá para arrastar. */
  scrollbar-width: thin;
}

.consulte-grid-rolagem-superior::-webkit-scrollbar {
  height: 10px;
  -webkit-appearance: none;
}

.consulte-grid-rolagem-superior::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.06);
}

.consulte-grid-rolagem-superior::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.35);
}

/* O "x" que desfaz a ordenação de uma coluna: discreto ao lado do ícone de ordenar, mas visível
   o bastante para o usuário achar quando ordenou pela coluna errada. */
.consulte-grid-remover-ordenacao {
  font-size: 15px;
  line-height: 1;
}

/* Só existe para dar largura ao conteúdo rolável; a altura é o mínimo que o mantém no fluxo. */
.consulte-grid-rolagem-superior-trilho {
  height: 1px;
}

.mobile-table-row {
  height: auto;
  min-height: 48px;
}

.mobile-row {
  height: auto !important;
  min-height: 48px;
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.table-mobile {
  line-height: 1.5;
  border-spacing: 0;
  width: 100%;
}

.table-mobile td {
  font-size: 0.875rem;
  height: 48px;
  transition: height 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

.table-mobile td {
  border-top: none;
  border-bottom: none;
  padding: 0 16px;
}

.table-mobile tr {
  border-color: inherit;
  border-style: solid;
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.mobile-row-header {
  font-weight: 600;
  text-align: left;
}

.mobile-row-cell {
  text-align: right;
}

.grid-footer {
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  height: 55px;
}

.grid-wrapper-consulte {
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  box-shadow: 1px 1px 6px #cdcdcd;
}

.grid-footer nav {
  padding: 0px;
}

.offcanvas-footer {
  padding: 1rem 1rem;
  border-top: 1px solid #dee2e6;
}

.mini-loader {
  margin: 10px 0;
  position: absolute;
  left: 46%;
}

/* Redimensionamento de coluna */
.consulte-grid-th-resizable {
  position: relative;
  background-clip: padding-box;
}

.col-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 6px;
  cursor: col-resize;
  user-select: none;
  z-index: 2;
  touch-action: none;
}

.col-resize-handle::after {
  content: '';
  position: absolute;
  top: 15%;
  bottom: 15%;
  right: 2px;
  width: 2px;
  border-radius: 1px;
  background: rgba(0, 0, 0, 0.2);
  transition: background-color 0.15s ease, width 0.15s ease;
}

.col-resize-handle:hover,
.col-resize-handle:active {
  background: rgba(0, 0, 0, 0.1);
}

.col-resize-handle:hover::after,
.col-resize-handle:active::after {
  background: #556ee6;
  width: 3px;
}

/*
 * A alça passou a ser focável (tabindex="0") para poder ser redimensionada pelas setas
 * do teclado. Como ela tem só 6px de largura e mora dentro do cabeçalho, o anel de foco
 * global ficaria escondido pelo `<th>` vizinho — aqui ele é desenhado por dentro, na
 * própria alça, e o traço central assume a cor de destaque para o alvo ficar óbvio.
 */
.col-resize-handle:focus-visible {
  outline: 2px solid #556ee6 !important;
  outline-offset: -1px !important;
  box-shadow: none !important;
  background: rgba(85, 110, 230, 0.15);
}

.col-resize-handle:focus-visible::after {
  background: #556ee6;
  width: 3px;
  top: 0;
  bottom: 0;
}

/* Fixar coluna */
.table-scroll {
  position: relative;
  margin: auto;
  overflow: hidden;
  border: 0px solid #000;
}

.table-wrap {
  width: 100%;
  overflow: auto;
}

.table-scroll table {
  width: 100%;
  margin: auto;
  border-collapse: separate;
}

.table-scroll th,
.table-scroll td {
  padding: 5px 10px;
  white-space: nowrap;
  vertical-align: top;
  color: #000;
}

.table-scroll thead,
.table-scroll tfoot {
  background: #f9f9f9;
}

.fixed-table {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}

.fixed-table th,
.fixed-table td {
  visibility: hidden;
}

.fixed-table td,
.fixed-table th {
  border-color: transparent;
}

.fixed-table tbody td {
  visibility: visible;
}

.fixed-table .fixed-side {
  border: 0px solid #000;
  background: #eee;
  visibility: visible;
}

/* Para esconder alguma tabela dentro de alguma coluna da tabela fixada */
.fixed-table tbody td:not(.fixed-side) {
  visibility: hidden;
}

.main-table:not(.fixed-table) td.fixed-side {
  visibility: hidden !important;
}

.fixed-table thead,
.fixed-table tfoot {
  background: transparent;
}
</style>
@/datasources/consulte-grid
